{
  "name": "kobize-web",
  "version": "0.0.5",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "20.3.13",
    "@angular/common": "20.3.13",
    "@angular/compiler": "20.3.13",
    "@angular/core": "20.3.13",
    "@angular/forms": "20.3.13",
    "@angular/platform-browser": "20.3.13",
    "@angular/platform-browser-dynamic": "20.3.13",
    "@angular/router": "20.3.13",
    "@ekowitryna/ui": "20.1.3-dev74",
    "@fortawesome/fontawesome-free": "^7.2.0",
    "@mobiletract/account-service-angular-client": "1.16.3-dev1",
    "@mobiletract/auth-service-angular-client": "1.17.2-dev",
    "@mobiletract/kobize-service-angular-client": "0.0.2-dev8",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@primeng/themes": "^20.0.0",
    "keycloak-angular": "^19.0.2",
    "keycloak-js": "^26.1.1",
    "primeicons": "^7.0.0",
    "primeng": "^20.4.0",
    "quill": "^2.0.3",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.3.13",
    "@angular/build": "20.3.13",
    "@angular/cli": "20.3.13",
    "@angular/compiler-cli": "20.3.13",
    "@tailwindcss/postcss": "^4.0.15",
    "@types/jasmine": "~5.1.0",
    "jasmine-core": "~5.9.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "postcss": "^8.4.47",
    "typescript": "~5.9.2"
  }
}
